module.exports = "<div class=\"<%= notification %>\" ng-class=\"{'<%= notification_open %>': open}\">\r\n    <div class=\"<%= notification__displacededstuff %>\">\r\n        <ng-transclude></ng-transclude>\r\n    </div>\r\n\r\n    {{ text }}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileNotification/Notification.html
// module id = 431
// module chunks = 0